// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/EncodeSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/EncodeSans-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/EncodeSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/EncodeSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./images/230602_micrositio_Campana_contra_las_violencias_de_genero_ elementos_body home-05.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./images/elementos_movil-v1_body-20.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./images/230602_micrositio_campana_contra _las _violencias_de_genero_ elementos_body_solapa.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./images/elementos_movil-v1_body-segundo-fondo-sin-logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
* {
  margin: 0;
  padding: 0;
}

@font-face {
  font-family: "EncodeSans-Bold";
  src: local("EncodeSans-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "EncodeSans-Black";
  src: local("EncodeSans-Black"), url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "EncodeSans-Medium";
  src: local("EncodeSans-Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "EncodeSans-SemiBold";
  src: local("EncodeSans-SemiBold"), url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.encodesans-bold {
  font-family: "EncodeSans-Bold";
}

.encodesans-black {
  font-family: "EncodeSans-Black";
}

.encodesans-medium {
  font-family: "EncodeSans-Medium";
}

.encodesans-semiBold {
  font-family: "EncodeSans-SemiBold";
}

.btn-inicio {
  position: absolute;
  right: 20px;
  top: 16%;
  transform: translateY(-50%);
  background-color: #322B4D;
  color: #E7E7E7;
  width: -moz-fit-content;
  width: fit-content;
  margin: 5px;
  padding: 10px;
  border-radius: 5px;
  text-decoration: none;
}

/* principal page*/
.HomeBody {
  width: 80%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-repeat: round !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  text-align: center;
}

.paragraph-principal {
  color: #E7E7E7;
  width: 70% !important;
  height: 30%;
  font-weight: 400;
  font-size: 1.3em;
  padding-top: 118px;
  text-align: justify;
}

.paragraph-second {
  color: #E7E7E7;
  width: 70% !important;
  height: 30%;
  font-weight: 400;
  font-size: 1.3em;
  margin-top: 30px;
  text-align: justify;
}

.imgEncabezado {
  vertical-align: bottom;
}

/*  infinite marquee*/
#marquee-container {
  width: 90%;
  margin: 0 10px;
  overflow: hidden;
  box-sizing: border-box;
}

.img-carrousel {
  width: 80%;
  height: auto;
}

#marquee-track {
  display: flex;
  margin-bottom: 60px;
  animation: marquee 64s linear infinite; /* Cambiado a 64s para reflejar el tiempo doble */
  animation-timing-function: linear;
}

.marquee-content {
  margin-right: 20px; /* Espacio entre las imágenes */
  flex-shrink: 0; /* Evita que las imágenes se redimensionen */
}

@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  50% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0%);
  }
}
/*.div--carousel {
  background-color: #E7E7E7;
} */
/* principal page mobile*/
.header--mobile {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  display: grid;
  place-content: center;
}

/* nav */
.conteiner--nav__mobile {
  max-width: calc(100% - 50px);
  padding: 25px;
}

.title--mobile {
  border-radius: 5px;
  color: #E7E7E7;
  text-align: center;
  background-color: #322B4D;
  max-width: calc(100% - 50px);
  padding: 25px;
}

.title--mobile_link {
  text-decoration: none;
  color: #E7E7E7;
}

.paragraph--mobile {
  color: #322B4D;
  background-color: #E7E7E7;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.5rem;
  max-width: calc(100% - 50px);
  padding: 25px;
}

/* background del menu vertical */
.div-nav {
  background-color: #9283BE;
  height: 232vh;
}

/* videoSpot */
.video-container {
  width: 80%;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 10%;
  margin-bottom: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-wrapper {
  aspect-ratio: 16/9;
  overflow: hidden;
}

.responsive-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* solapas    */
/* paragraph */
.paragraph-genero {
  width: 70% !important;
  color: #322B4D;
  margin-bottom: 20px;
  font-size: 1rem;
}

img {
  width: 100%;
  height: auto;
}

.mi-linea-horizontal {
  width: 50%; /* Cambia el color de la línea horizontal */
  border: 3px dashed #322B4D;
  margin: 20px 0 60px;
}

/* Vistas del menu vertical*/
.main--buttons {
  padding: 70px 40px 70px 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: cover;
  background-repeat: repeat-x;
  width: auto;
  height: auto;
}

.title-recursos {
  height: 80px;
  width: 80%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  background-color: #a29dab;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5) !important;
}
.title-recursos h1 {
  display: grid;
  color: aliceblue;
  place-content: center;
  font-size: 1.2em;
  margin: auto;
}

/*   */
.main--buttons_recursos {
  padding: 100px 40px 70px 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: cover;
  background-repeat: repeat-x;
  width: auto;
  height: auto;
}

/* Buttons */
.buttons {
  background-color: #322B4D;
  color: #E7E7E7;
  display: flex;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
  margin: 5px;
  padding: 10px;
  border-radius: 5px;
  text-decoration: none;
}
.buttons img {
  width: 16px;
  height: 16px;
  margin-right: 15px;
}

.contenedor-buttons {
  display: grid;
  place-items: flex-start;
}
.contenedor-buttons h3 {
  font-size: 18px;
  color: #322B4D;
  margin-top: 10px;
  margin-bottom: 20px;
  font-family: encodesans-semiBold;
}

.main--solapas {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: cover;
  background-repeat: repeat-x;
  width: auto;
  height: auto;
}
.main--solapas h1 {
  font-size: 35px;
  color: #322B4D;
  margin-bottom: 20px;
}

.main--solapas_custumizado {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: cover;
  background-repeat: repeat-x;
  width: auto;
  height: 100vh;
}
.main--solapas_custumizado h1 {
  font-size: 35px;
  color: #322B4D;
  margin-bottom: 20px;
}

.padding {
  padding: 70px 40px 70px 40px;
}

/* menu horizontal desktop*/
.conteiner-menus-desktop {
  display: flex;
  height: 80px;
}

.nav-menu--horizontal {
  width: 80%;
  background-color: #D6E034;
  display: flex;
  justify-content: center;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

.a-link-nav-menu--horizontal {
  padding: 1.5%;
  width: 20%;
  text-decoration: none;
  text-align: center;
  color: #444346;
  box-shadow: 5px 0 0px 0;
  display: flex;
  font-weight: 700;
  flex-direction: column;
  justify-content: center;
  font-size: 1em;
}

.active {
  background-color: #322B4D;
  color: #E7E7E7;
}

/*menu horizontal mobile */
.section-menu-mobile {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.section-menu-mobile img {
  width: 100%;
}

.container-a-mobile {
  display: flex;
  flex-direction: column;
  font-weight: 600;
}

.container-a-mobile a {
  text-decoration: none;
  color: #444346;
  line-height: 2rem;
}

.isActive {
  display: flex;
  height: 100vh;
  opacity: 1;
  height: 100%;
}

.toggleMenu--Mobile {
  position: relative;
}

.btn-mobile {
  position: absolute;
  top: 17px;
  /* right: -107px; */
  left: 126px;
  width: 26px;
  height: 26px;
}

/* mobile_vistas*/
.article--movil {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
}

.div-paragraph__movil {
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: column;
}
.div-paragraph__movil img {
  width: 307px;
  height: 140px;
}

.paragraph-movil {
  color: #E7E7E7;
  width: 80%;
  font-weight: 400;
  font-size: 1.3em;
}

/* A voz alzada */
.title-aVozAlzada {
  height: 80px;
  width: 80%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  background-color: #a29dab;
}
.title-aVozAlzada h1 {
  display: grid;
  color: aliceblue;
  place-content: center;
  font-size: 1.2em;
  margin: auto;
}

.main--aVozAlzada {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.main--aVozAlzada p {
  width: 70%;
  font-size: 1.3em;
  padding: 30px;
  color: #322B4D;
}

/* vertical menu desktop */
/*  contenedor de los menus que estan dentro del header   */
.nav {
  width: 300px;
}

.nav__link {
  color: #322B4D !important;
  display: block;
  padding: 15px 0;
  text-decoration: none;
  height: 50px;
}

.nav__link--inside {
  padding-left: 20px;
  text-align: left;
  background-color: #E7E7E7;
  border: 1px solid #51B8B1;
}

.nav__link--inside:hover {
  color: #51B8B1 !important;
}

.list {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  background-color: #51B8B1;
}

.list__item {
  list-style: none;
  width: 100%;
  text-align: left;
  overflow: hidden;
  border-bottom: 2px solid #E7E7E7;
}

.list__item--click {
  cursor: pointer;
}

.list__item_map {
  list-style: none;
  width: 100%;
  text-align: left;
  overflow: hidden;
  border-bottom: 2px solid #E7E7E7;
  height: 115px;
}

.list__button {
  display: flex;
  align-items: center;
  gap: 1em;
  width: 70%;
  margin: 0 auto;
}

.btn-home__mobile {
  width: 100%;
  color: #322B4D;
  background-color: #51B8B1;
  cursor: pointer;
  padding: 15px 0;
  text-decoration: none;
  border: 0;
  text-align: left;
  font-size: 16px;
}

.arrow .list__arrow {
  transform: rotate(90deg);
}

.list__arrow {
  margin-left: auto;
  transition: transform 0.4s;
}

.list__sub__item {
  max-height: 300px !important;
  overflow-y: scroll !important;
  list-style: none;
  display: none;
  scrollbar-color: #322B4D #95f8f1 !important;
  scrollbar-width: thin !important;
}

.list__show {
  display: block;
  transition: ease 0.8s;
  opacity: 100;
}

.list__hide {
  display: none;
  transition: opacity 200ms, display 200ms;
  opacity: 0;
}

.div_ultima_menu {
  background-color: yellow;
  display: flex;
  height: 100vh;
}

.list__button_ultima_menu {
  overflow: hidden;
  height: 100vh;
}

/* grilla de fotos del menu vertical*/
.image-grid-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 70%;
}

.image-grid-items {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px; /* Ajusta este valor según el margen deseado */
}

.image-grid-item {
  margin: 0;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  text-align: center;
}

.buttons {
  margin-top: 10px;
}

/*  panel de cards de pdfs */
.container_cards_viewpdf {
  padding: 30px;
  max-width: calc(100% - 50px);
  background-color: #E7E7E7;
}

.conteiner-title--btn_card {
  width: 300px;
  height: 280px !important; /* Establece la altura de la tarjeta */
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid #9283BE;
  border-radius: 5px;
  background-color: #fff;
  max-width: calc(100% - 50px);
}

.card-title {
  color: #E7E7E7;
  background-color: #9283BE;
  width: 100%;
  height: 85px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  font-size: 0.8rem;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* Ajusta el ancho mínimo y máximo */
  grid-gap: 20px;
  width: 100%;
}

.main--pdfs {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  min-height: 100vh;
  width: 80%;
}

.btn {
  width: 100%;
}

.image-card {
  width: 258px;
  height: 195px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.img-footer-desktopprincipal {
  width: 100%;
}

/* Media querys  */
@media (min-width: 1920px) {
  .main--solapas, .main--buttons {
    padding: 90px 40px 90px 40px;
  }
  .main--solapas h1 {
    font-size: 2.7em;
  }
  .main--buttons {
    padding: 85px;
  }
  .title-recursos {
    padding: 15px;
  }
  .main--buttons h1 {
    font-size: 2.2em;
  }
  h1 {
    font-size: 1.6em;
  }
  h2 {
    font-size: 1.9em;
  }
  .paragraph-genero, h3 {
    font-size: 1.4em;
  }
  .paragraph-principal, .paragraph-second {
    font-size: 1.8em;
  }
  /*Menu horizontal  */
  .nav-menu--horizontal {
    height: 110px;
  }
  /*Menu vertical  */
  .list__button {
    padding: 15px;
  }
  .title-aVozAlzada {
    height: 125px;
    text-align: center;
  }
  .nav {
    width: 400px;
  }
  .navLink_solapas {
    text-decoration: none;
    position: absolute;
    position: absolute;
    top: 320px;
    left: 10px;
  }
  .nav__link--inside:hover {
    color: #51B8B1 !important;
  }
  .contenedor-buttons h3 {
    font-size: 2rem;
  }
}
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .a-link-nav-menu--horizontal {
    font-size: 0.7em;
  }
  .nav {
    width: 250px;
  }
  .nav__link {
    font-size: 0.8rem;
  }
}
@media (max-width: 768px) {
  .nav {
    width: 100%;
  }
  .nav__link--inside:hover {
    color: #51B8B1 !important;
  }
  .section-menu-mobile {
    display: flex;
    flex-direction: column;
  }
  .section-menu-mobile img {
    width: 100%;
  }
  .container-a-mobile {
    display: flex;
    flex-direction: column;
    font-weight: 600;
    height: 100%;
  }
  .container-a-mobile a {
    text-decoration: none;
    color: #444346;
    line-height: 2rem;
  }
  .isActive {
    display: block;
    transition: transform 0.4s;
    opacity: 100;
    height: 100%;
  }
  .main--solapas h1 {
    margin: 5px;
    color: #322B4D;
    padding: 15px;
    text-align: center;
    margin-bottom: 15px;
    font-size: 1.75rem;
  }
  /*  contenedor imagenes a voz alzada */
  .image-grid-container {
    width: 100%;
  }
  .main--pdfs {
    width: 80%;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  #width-view {
    width: 50%;
  }
  #height_view__h1 {
    font-size: 1.55rem;
  }
  #height_view__titulo {
    font-size: 1.25rem;
  }
  #height_view__tituloimg {
    font-size: 0.9rem;
    max-width: calc(100% - 25px);
  }
}
@media screen and (min-width: 901px) {
  #nav-menu--horizontal {
    display: flex !important;
  }
  #VerticalDrownMenu {
    display: flex !important;
  }
  #nav-vertical-mobile {
    display: none !important;
  }
  #header--destkop {
    display: flex !important;
  }
  .HomeBody {
    display: flex !important;
  }
  #article--movil {
    display: none !important;
  }
  #footer_viewprincipal {
    display: block !important;
  }
  #header--destkop__div {
    display: block !important;
  }
  #footer_viewpimagenes {
    display: none !important;
  }
}
@media screen and (max-width: 901px) {
  #nav-vertical {
    display: flex !important;
  }
  #nav-menu--horizontal {
    display: none !important;
  }
  #VerticalDrownMenu {
    display: none !important;
  }
  #nav-vertical-mobile {
    display: block !important;
  }
  #header--destkop {
    display: none;
  }
  .HomeBody {
    display: none !important;
  }
  #article--movil {
    display: block !important;
  }
  #footer_viewprincipal {
    display: none !important;
  }
  #header--destkop__div {
    display: none !important;
  }
  #footer_viewpimagenes {
    display: block !important;
  }
  .container_cards_viewpdf {
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; /* Centra verticalmente */
    padding: 30px;
    background-color: #E7E7E7;
    max-width: calc(100% - 25px);
  }
  .conteiner-title--btn_card {
    width: auto;
    height: auto;
    margin-bottom: 15px;
  }
  .main--solapas {
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
  .buttons {
    line-height: 1rem;
  }
  .main--solapas h1 {
    color: #322B4D;
    padding: 10px;
    text-align: center;
  }
  .title-aVozAlzada {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    background-color: #a29dab;
    height: 90px;
  }
  .title-aVozAlzada h1 {
    text-align: center;
    color: aliceblue;
    font-size: 1.125rem;
    margin: auto;
  }
  .title-recursos {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    background-color: #a29dab;
    height: 90px;
  }
  .main--aVozAlzada p {
    width: 70%;
    font-size: 1.125rem;
    line-height: 1.5rem;
    color: #322B4D;
  }
  .image-card {
    width: 260px;
  }
  .nav__link--inside:hover {
    color: #51B8B1 !important;
  }
}
@media (max-width: 500px) {
  .paragraph-principal, .paragraph-second, .paragraph-genero {
    font-size: 0.8em;
  }
  h1, h2 {
    font-size: 1em;
  }
  .main--solapas h1 {
    font-size: 1.35rem;
    margin: 0;
  }
  .buttons {
    font-size: 0.6em;
  }
  .nav__link {
    height: auto !important;
  }
  .navLink_solapas {
    display: none;
  }
  /* Imagenes de la grilla voz alzada SEGUIR TRABAJANDO*/
  /* video spot */
  .video-container {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    margin-top: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image-grid-items {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  }
  .main--aVozAlzada p {
    width: 70%;
    font-size: 1.125rem;
    line-height: 1.5rem;
    color: #322B4D;
  }
  .title-aVozAlzada {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    background-color: #a29dab;
    height: 60px;
  }
  .title-aVozAlzada h1 {
    text-align: center;
    color: #E7E7E7;
    font-size: 0.9rem;
    margin: auto;
  }
  .title-recursos {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    background-color: #a29dab;
    height: 60px;
  }
  .link-home {
    text-decoration: none;
    padding: 15px;
  }
  .mi-linea-horizontal {
    display: none !important;
  }
  .nav__link--inside:hover {
    color: #51B8B1 !important;
  }
  .main--buttons {
    padding: 15px 40px 15px 40px;
  }
  .title-recursos {
    height: 60px;
  }
}
@media (max-width: 320px) {
  .image-card {
    width: 214px;
  }
  .nav__link--inside:hover {
    color: #51B8B1 !important;
  }
  .title-aVozAlzada {
    height: 70px;
  }
  .title-recursos {
    height: 60px;
  }
  .main--solapas h1 {
    font-size: 1.35rem;
    margin: 0;
  }
  .main--buttons {
    padding: 15px 40px 15px 40px;
  }
  .main--buttons_recursos {
    padding: 15px 40px 15px 40px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles.css","webpack://./src/App.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,SAAA;EACA,UAAA;ADEF;;ACcA;EACE,8BAAA;EACA,sEAAA;ADXF;ACeA;EACE,+BAAA;EACA,uEAAA;ADbF;ACiBA;EACE,gCAAA;EACA,wEAAA;ADfF;ACmBA;EACE,kCAAA;EACA,0EAAA;ADjBF;ACsBA;EACE,8BAAA;ADpBF;;ACsBA;EACE,+BAAA;ADnBF;;ACqBE;EACA,gCAAA;ADlBF;;ACoBE;EACA,kCAAA;ADjBF;;ACoBA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,yBAlDQ;EAmDR,cAvDM;EAwDN,uBAAA;EAAA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;ADjBF;;ACoBA,kBAAA;AACA;EACE,UAAA;EACA,yDAAA;EACA,sBAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;ADjBF;;ACoBA;EACE,cA7EM;EA8EN,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;ADjBF;;ACmBA;EACE,cAtFM;EAuFN,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;ADhBF;;ACkBA;EACE,sBAAA;ADfF;;ACkBA,qBAAA;AACA;EACE,UAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;ADfF;;ACiBA;EACE,UAAA;EACA,YAAA;ADdF;;ACgBA;EACE,aAAA;EACA,mBAAA;EACA,sCAAA,EAAA,iDAAA;EACA,iCAAA;ADbF;;ACgBA;EACE,kBAAA,EAAA,+BAAA;EACA,cAAA,EAAA,4CAAA;ADbF;;ACgBA;EACE;IACE,yBAAA;EDbF;ECeA;IACE,4BAAA;EDbF;ECeA;IACE,yBAAA;EDbF;AACF;ACeA;;GAAA;AAGA,yBAAA;AACA;EACE,yDAAA;EACA,aAAA;EACA,qBAAA;ADbF;;ACgBA,QAAA;AACA;EACE,4BAAA;EACA,aAAA;ADbF;;ACeA;EACE,kBAAA;EACA,cArJM;EAsJN,kBAAA;EACA,yBAnJQ;EAoJR,4BAAA;EACA,aAAA;ADZF;;ACcA;EACE,qBAAA;EACA,cA7JM;ADkJR;;ACaA;EACE,cA5JQ;EA6JR,yBAjKM;EAkKN,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,aAAA;ADVF;;ACaA,iCAAA;AACA;EACE,yBAAA;EACA,aAAA;ADVF;;ACaA,cAAA;AACA;EACE,UAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ADVF;;ACYA;EACE,kBAAA;EACA,gBAAA;ADTF;;ACYA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ADTF;;ACYA,eAAA;AACA,cAAA;AACA;EACE,qBAAA;EACA,cArMQ;EAsMR,mBAAA;EACA,eAAA;ADTF;;ACWA;EACE,WAAA;EACA,YAAA;ADRF;;ACUA;EACE,UAAA,EAAA,2CAAA;EACA,0BAAA;EACA,mBAAA;ADPF;;ACSA,4BAAA;AACA;EACI,4BAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;ADNJ;;ACQA;EACE,YAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAnOO;EAoOP,sDAAA;ADLF;ACMI;EACE,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;ADJN;;ACOA,MAAA;AACA;EACE,6BAAA;EACE,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;ADJJ;;ACMA,YAAA;AACA;EACE,yBAtPQ;EAuPR,cA3PM;EA4PN,aAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;ADHF;ACIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ADFJ;;ACKA;EACE,aAAA;EACA,uBAAA;ADFF;ACGE;EACE,eAAA;EACA,cA1QM;EA2QN,gBAAA;EACA,mBAAA;EACA,gCAAA;ADDJ;;ACIA;EACE,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;ADDF;ACEE;EACE,eAAA;EACA,cAxRM;EAyRN,mBAAA;ADAJ;;ACGA;EACE,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;ADAF;ACCE;EACE,eAAA;EACA,cApSM;EAqSN,mBAAA;ADCJ;;ACEA;EACE,4BAAA;ADCF;;ACCA,2BAAA;AACA;EACE,aAAA;EACA,YAAA;ADEF;;ACAA;EACE,UAAA;EACA,yBAvTK;EAwTL,aAAA;EACA,uBAAA;EACA,2CAAA;ADGF;;ACDA;EACE,aAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,cA/TO;EAgUP,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;ADIF;;ACFA;EACE,yBArUQ;EAsUR,cA1UM;AD+UR;;ACHA,0BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;ADMF;;ACJA;EACE,WAAA;ADOF;;ACLA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;ADQF;;ACLA;EACE,qBAAA;EACA,cA5VO;EA6VP,iBAAA;ADQF;;ACLA;EACE,aAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;ADQF;;ACNA;EACE,kBAAA;ADSF;;ACPA;EACE,kBAAA;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;ADUJ;;ACRA,iBAAA;AACA;EACE,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,iBAAA;ADWF;;ACTA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;ADYF;ACXI;EACE,YAAA;EACA,aAAA;ADaN;;ACVA;EACE,cApYM;EAqYN,UAAA;EACA,gBAAA;EACA,gBAAA;ADaF;;ACVA,iBAAA;AACA;EACE,YAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBA/YO;AD4ZT;ACZI;EACE,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;ADcN;;ACXA;EACE,yDAAA;ADcF;ACbI;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,cA5ZI;AD2aV;;ACVA,0BAAA;AACA,2DAAA;AACA;EACE,YAAA;ADaF;;ACVA;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;ADaF;;ACVA;EACE,kBAAA;EACA,gBAAA;EACA,yBAtbM;EAubN,yBAAA;ADaF;;ACXA;EACE,yBAAA;ADcF;;ACZA;EACE,WAAA;EAEA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBA5bM;AD0cR;;ACXA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;ADcF;;ACZA;EACE,eAAA;ADeF;;ACbA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;ADgBF;;ACdA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;ADiBF;;ACfA;EACE,WAAA;EACA,cA5dQ;EA6dR,yBA3dM;EA4dN,eAAA;EACA,eAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;ADkBF;;AChBA;EACE,wBAAA;ADmBF;;AChBA;EACE,iBAAA;EACA,0BAAA;ADmBF;;AChBA;EACE,4BAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,gCAAA;ADmBF;;AChBA;EACE,cAAA;EACA,qBAAA;EACA,YAAA;ADmBF;;AChBA;EACE,aAAA;EACA,wCAAA;EACA,UAAA;ADmBF;;AChBA;EACE,wBAAA;EACA,aAAA;EACA,aAAA;ADmBF;;ACjBA;EACE,gBAAA;EACA,aAAA;ADoBF;;AClBA,qCAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;ADqBF;;AClBA;EACE,aAAA;EACA,qCAAA;EACA,SAAA,EAAA,8CAAA;ADqBF;;AClBA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;ADqBF;;AClBA;EACE,gBAAA;ADqBF;;AClBA,4BAAA;AACA;EACE,aAAA;EACA,4BAAA;EACA,yBA9iBM;ADmkBR;;AClBA;EACE,YAAA;EACA,wBAAA,EAAA,sCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBA3jBM;EA4jBN,4BAAA;ADqBF;;AClBA;EACE,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;ADqBF;;AClBA;EACE,aAAA;EACA,2DAAA,EAAA,oCAAA;EACA,cAAA;EACA,WAAA;ADqBF;;AClBA;EACE,yDAAA;EACA,iBAAA;EACA,UAAA;ADqBF;;AClBA;EACE,WAAA;ADqBF;;AClBA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACE,sBAAA;EACA,yBAAA;EACA,mBAAA;ADqBJ;;AClBA;EACE,WAAA;ADqBF;;AClBA,kBAAA;AACA;EACE;IACE,4BAAA;EDqBF;ECnBA;IACE,gBAAA;EDqBF;ECnBA;IACE,aAAA;EDqBF;ECnBA;IACE,aAAA;EDqBF;ECnBA;IACE,gBAAA;EDqBF;ECnBA;IACE,gBAAA;EDqBF;ECnBA;IACE,gBAAA;EDqBF;EClBA;IACE,gBAAA;EDoBF;EClBA;IACE,gBAAA;EDoBF;EClBA,oBAAA;EACA;IACE,aAAA;EDoBF;EClBC,kBAAA;EACD;IACA,aAAA;EDoBA;EClBA;IACE,aAAA;IACA,kBAAA;EDoBF;EClBA;IACE,YAAA;EDoBF;EClBA;IACE,qBAAA;IACA,kBAAA;IACE,kBAAA;IACA,UAAA;IACA,UAAA;EDoBJ;EClBA;IACE,yBAAA;EDoBF;ECjBE;IACE,eAAA;EDmBJ;AACF;ACfA;EACE;IACE,gBAAA;EDiBF;ECfA;IACE,YAAA;EDiBF;ECfA;IACE,iBAAA;EDiBF;AACF;ACdA;EACE;IACE,WAAA;EDgBF;ECdA;IACE,yBAAA;EDgBF;ECdA;IACE,aAAA;IACA,sBAAA;EDgBF;ECdA;IACE,WAAA;EDgBF;ECdA;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,YAAA;EDgBF;ECdA;IACE,qBAAA;IACA,cAxsBK;IAysBL,iBAAA;EDgBF;ECdA;IACE,cAAA;IACA,0BAAA;IACA,YAAA;IACA,YAAA;EDgBF;ECbA;IACE,WAAA;IACA,cAjtBM;IAktBN,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;EDeF;ECbD,sCAAA;EACD;IACE,WAAA;EDeA;ECbF;IACE,UAAA;EDeA;AACF;ACXA;EACE;IACE,UAAA;EDaF;ECXA;IACE,kBAAA;EDaF;ECXA;IACE,kBAAA;EDaF;ECXA;IACE,iBAAA;IACA,4BAAA;EDaF;AACF;ACVA;EACE;IACE,wBAAA;EDYF;ECVA;IACE,wBAAA;EDYF;ECVA;IACE,wBAAA;EDYF;ECVA;IACE,wBAAA;EDYF;ECVA;IACE,wBAAA;EDYF;ECVA;IACE,wBAAA;EDYF;ECVA;IACE,yBAAA;EDYF;ECVA;IACE,yBAAA;EDYF;ECVA;IACE,wBAAA;EDYF;AACF;ACRA;EAEI;IACE,wBAAA;EDSJ;ECPE;IACI,wBAAA;EDSN;ECPI;IACE,wBAAA;EDSN;ECPI;IACE,yBAAA;EDSN;ECPI;IACE,aAAA;EDSN;ECPI;IACE,wBAAA;EDSN;ECPI;IACE,yBAAA;EDSN;ECPI;IACE,wBAAA;EDSN;ECPI;IACE,wBAAA;EDSN;ECPI;IACE,yBAAA;EDSN;ECPE;IACE,WAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA,EAAA,yBAAA;IACA,aAAA;IACA,yBA3zBE;IA4zBF,4BAAA;EDSJ;ECPE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EDSJ;ECPE;IACE,mBAAA;IACA,mBAAA;EDSJ;ECPE;IACE,iBAAA;EDSJ;ECPE;IACE,cAv0BI;IAw0BJ,aAAA;IACA,kBAAA;EDSJ;ECPE;IACE,WAAA;IACA,aAAA;IACA,yBAAA;IACA,sBAAA;IACA,yBAAA;IACA,YAAA;EDSJ;ECRM;IACE,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,YAAA;EDUR;ECPE;IACE,WAAA;IACA,aAAA;IACA,yBAAA;IACA,sBAAA;IACA,yBAAA;IACA,YAAA;EDSJ;ECNM;IACE,UAAA;IACA,mBAAA;IACA,mBAAA;IACA,cAt2BA;ED82BR;ECLE;IACE,YAAA;EDOJ;ECLE;IACE,yBAAA;EDOJ;AACF;ACJI;EACE;IACE,gBAAA;EDMN;ECJI;IACE,cAAA;EDMN;ECJI;IACE,kBAAA;IACA,SAAA;EDMN;ECJI;IACE,gBAAA;EDMN;ECJI;IACE,uBAAA;EDMN;ECJI;IACE,aAAA;EDMN;ECJI,sDAAA;EAEA,eAAA;EACA;IACE,WAAA;IACA,iBAAA;IACA,cAAA;IACA,eAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EDKN;ECFI;IACE,aAAA;IACA,qCAAA;IACA,SAAA;EDIN;ECDM;IACE,UAAA;IACA,mBAAA;IACA,mBAAA;IACA,cA55BA;ED+5BR;ECAI;IACE,WAAA;IACA,aAAA;IACA,yBAAA;IACA,sBAAA;IACA,yBAAA;IACA,YAAA;EDEN;ECDQ;IACE,kBAAA;IACA,cA56BJ;IA66BI,iBAAA;IACA,YAAA;EDGV;ECAI;IACE,WAAA;IACA,aAAA;IACA,yBAAA;IACA,sBAAA;IACA,yBAAA;IACA,YAAA;EDEN;ECAI;IACE,qBAAA;IACA,aAAA;EDEN;ECAI;IACE,wBAAA;EDEN;ECAI;IACE,yBAAA;EDEN;ECAI;IACE,4BAAA;EDEN;ECAI;IACE,YAAA;EDEN;AACF;ACCI;EACE;IACE,YAAA;EDCN;ECCI;IACE,yBAAA;EDCN;ECCI;IACE,YAAA;EDCN;ECCI;IACE,YAAA;EDCN;ECCI;IACE,kBAAA;IACA,SAAA;EDCN;ECCI;IACE,4BAAA;EDCN;ECCI;IACE,4BAAA;EDCN;AACF","sourcesContent":["@charset \"UTF-8\";\n* {\n  margin: 0;\n  padding: 0;\n}\n\n@font-face {\n  font-family: \"EncodeSans-Bold\";\n  src: local(\"EncodeSans-Bold\"), url(\"./fonts/EncodeSans-Bold.ttf\");\n}\n@font-face {\n  font-family: \"EncodeSans-Black\";\n  src: local(\"EncodeSans-Black\"), url(\"./fonts/EncodeSans-Black.ttf\");\n}\n@font-face {\n  font-family: \"EncodeSans-Medium\";\n  src: local(\"EncodeSans-Medium\"), url(\"./fonts/EncodeSans-Medium.ttf\");\n}\n@font-face {\n  font-family: \"EncodeSans-SemiBold\";\n  src: local(\"EncodeSans-SemiBold\"), url(\"./fonts/EncodeSans-SemiBold.ttf\");\n}\n.encodesans-bold {\n  font-family: \"EncodeSans-Bold\";\n}\n\n.encodesans-black {\n  font-family: \"EncodeSans-Black\";\n}\n\n.encodesans-medium {\n  font-family: \"EncodeSans-Medium\";\n}\n\n.encodesans-semiBold {\n  font-family: \"EncodeSans-SemiBold\";\n}\n\n.btn-inicio {\n  position: absolute;\n  right: 20px;\n  top: 16%;\n  transform: translateY(-50%);\n  background-color: #322B4D;\n  color: #E7E7E7;\n  width: fit-content;\n  margin: 5px;\n  padding: 10px;\n  border-radius: 5px;\n  text-decoration: none;\n}\n\n/* principal page*/\n.HomeBody {\n  width: 80%;\n  background-image: url(\"./images/230602_micrositio_Campana_contra_las_violencias_de_genero_ elementos_body home-05.png\");\n  background-size: cover;\n  background-repeat: round !important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  text-align: center;\n}\n\n.paragraph-principal {\n  color: #E7E7E7;\n  width: 70% !important;\n  height: 30%;\n  font-weight: 400;\n  font-size: 1.3em;\n  padding-top: 118px;\n  text-align: justify;\n}\n\n.paragraph-second {\n  color: #E7E7E7;\n  width: 70% !important;\n  height: 30%;\n  font-weight: 400;\n  font-size: 1.3em;\n  margin-top: 30px;\n  text-align: justify;\n}\n\n.imgEncabezado {\n  vertical-align: bottom;\n}\n\n/*  infinite marquee*/\n#marquee-container {\n  width: 90%;\n  margin: 0 10px;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.img-carrousel {\n  width: 80%;\n  height: auto;\n}\n\n#marquee-track {\n  display: flex;\n  margin-bottom: 60px;\n  animation: marquee 64s linear infinite; /* Cambiado a 64s para reflejar el tiempo doble */\n  animation-timing-function: linear;\n}\n\n.marquee-content {\n  margin-right: 20px; /* Espacio entre las imágenes */\n  flex-shrink: 0; /* Evita que las imágenes se redimensionen */\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(0%);\n  }\n  50% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n}\n/*.div--carousel {\n  background-color: #E7E7E7;\n} */\n/* principal page mobile*/\n.header--mobile {\n  background-image: url(\"./images/elementos_movil-v1_body-20.svg\");\n  display: grid;\n  place-content: center;\n}\n\n/* nav */\n.conteiner--nav__mobile {\n  max-width: calc(100% - 50px);\n  padding: 25px;\n}\n\n.title--mobile {\n  border-radius: 5px;\n  color: #E7E7E7;\n  text-align: center;\n  background-color: #322B4D;\n  max-width: calc(100% - 50px);\n  padding: 25px;\n}\n\n.title--mobile_link {\n  text-decoration: none;\n  color: #E7E7E7;\n}\n\n.paragraph--mobile {\n  color: #322B4D;\n  background-color: #E7E7E7;\n  font-weight: 600;\n  font-size: 1.125rem;\n  line-height: 1.5rem;\n  max-width: calc(100% - 50px);\n  padding: 25px;\n}\n\n/* background del menu vertical */\n.div-nav {\n  background-color: #9283BE;\n  height: 232vh;\n}\n\n/* videoSpot */\n.video-container {\n  width: 80%;\n  max-width: 1000px;\n  margin: 0 auto;\n  margin-top: 10%;\n  margin-bottom: 10%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.video-wrapper {\n  aspect-ratio: 16/9;\n  overflow: hidden;\n}\n\n.responsive-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* solapas    */\n/* paragraph */\n.paragraph-genero {\n  width: 70% !important;\n  color: #322B4D;\n  margin-bottom: 20px;\n  font-size: 1rem;\n}\n\nimg {\n  width: 100%;\n  height: auto;\n}\n\n.mi-linea-horizontal {\n  width: 50%; /* Cambia el color de la línea horizontal */\n  border: 3px dashed #322B4D;\n  margin: 20px 0 60px;\n}\n\n/* Vistas del menu vertical*/\n.main--buttons {\n  padding: 70px 40px 70px 40px;\n  background-image: url(\"./images/230602_micrositio_campana_contra _las _violencias_de_genero_ elementos_body_solapa.svg\");\n  background-size: cover;\n  background-repeat: repeat-x;\n  width: auto;\n  height: auto;\n}\n\n.title-recursos {\n  height: 80px;\n  width: 80%;\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n  background-color: #a29dab;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5) !important;\n}\n.title-recursos h1 {\n  display: grid;\n  color: aliceblue;\n  place-content: center;\n  font-size: 1.2em;\n  margin: auto;\n}\n\n/*   */\n.main--buttons_recursos {\n  padding: 100px 40px 70px 40px;\n  background-image: url(\"./images/230602_micrositio_campana_contra _las _violencias_de_genero_ elementos_body_solapa.svg\");\n  background-size: cover;\n  background-repeat: repeat-x;\n  width: auto;\n  height: auto;\n}\n\n/* Buttons */\n.buttons {\n  background-color: #322B4D;\n  color: #E7E7E7;\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  margin: 5px;\n  padding: 10px;\n  border-radius: 5px;\n  text-decoration: none;\n}\n.buttons img {\n  width: 16px;\n  height: 16px;\n  margin-right: 15px;\n}\n\n.contenedor-buttons {\n  display: grid;\n  place-items: flex-start;\n}\n.contenedor-buttons h3 {\n  font-size: 18px;\n  color: #322B4D;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  font-family: encodesans-semiBold;\n}\n\n.main--solapas {\n  background-image: url(\"./images/230602_micrositio_campana_contra _las _violencias_de_genero_ elementos_body_solapa.svg\");\n  background-size: cover;\n  background-repeat: repeat-x;\n  width: auto;\n  height: auto;\n}\n.main--solapas h1 {\n  font-size: 35px;\n  color: #322B4D;\n  margin-bottom: 20px;\n}\n\n.main--solapas_custumizado {\n  background-image: url(\"./images/230602_micrositio_campana_contra _las _violencias_de_genero_ elementos_body_solapa.svg\");\n  background-size: cover;\n  background-repeat: repeat-x;\n  width: auto;\n  height: 100vh;\n}\n.main--solapas_custumizado h1 {\n  font-size: 35px;\n  color: #322B4D;\n  margin-bottom: 20px;\n}\n\n.padding {\n  padding: 70px 40px 70px 40px;\n}\n\n/* menu horizontal desktop*/\n.conteiner-menus-desktop {\n  display: flex;\n  height: 80px;\n}\n\n.nav-menu--horizontal {\n  width: 80%;\n  background-color: #D6E034;\n  display: flex;\n  justify-content: center;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n}\n\n.a-link-nav-menu--horizontal {\n  padding: 1.5%;\n  width: 20%;\n  text-decoration: none;\n  text-align: center;\n  color: #444346;\n  box-shadow: 5px 0 0px 0;\n  display: flex;\n  font-weight: 700;\n  flex-direction: column;\n  justify-content: center;\n  font-size: 1em;\n}\n\n.active {\n  background-color: #322B4D;\n  color: #E7E7E7;\n}\n\n/*menu horizontal mobile */\n.section-menu-mobile {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.section-menu-mobile img {\n  width: 100%;\n}\n\n.container-a-mobile {\n  display: flex;\n  flex-direction: column;\n  font-weight: 600;\n}\n\n.container-a-mobile a {\n  text-decoration: none;\n  color: #444346;\n  line-height: 2rem;\n}\n\n.isActive {\n  display: flex;\n  height: 100vh;\n  opacity: 1;\n  height: 100%;\n}\n\n.toggleMenu--Mobile {\n  position: relative;\n}\n\n.btn-mobile {\n  position: absolute;\n  top: 17px;\n  /* right: -107px; */\n  left: 126px;\n  width: 26px;\n  height: 26px;\n}\n\n/* mobile_vistas*/\n.article--movil {\n  background-image: url(\"./images/elementos_movil-v1_body-segundo-fondo-sin-logo.svg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n}\n\n.div-paragraph__movil {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.div-paragraph__movil img {\n  width: 307px;\n  height: 140px;\n}\n\n.paragraph-movil {\n  color: #E7E7E7;\n  width: 80%;\n  font-weight: 400;\n  font-size: 1.3em;\n}\n\n/* A voz alzada */\n.title-aVozAlzada {\n  height: 80px;\n  width: 80%;\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n  background-color: #a29dab;\n}\n.title-aVozAlzada h1 {\n  display: grid;\n  color: aliceblue;\n  place-content: center;\n  font-size: 1.2em;\n  margin: auto;\n}\n\n.main--aVozAlzada {\n  background-image: url(\"./images/230602_micrositio_campana_contra _las _violencias_de_genero_ elementos_body_solapa.svg\");\n}\n.main--aVozAlzada p {\n  width: 70%;\n  font-size: 1.3em;\n  padding: 30px;\n  color: #322B4D;\n}\n\n/* vertical menu desktop */\n/*  contenedor de los menus que estan dentro del header   */\n.nav {\n  width: 300px;\n}\n\n.nav__link {\n  color: #322B4D !important;\n  display: block;\n  padding: 15px 0;\n  text-decoration: none;\n  height: 50px;\n}\n\n.nav__link--inside {\n  padding-left: 20px;\n  text-align: left;\n  background-color: #E7E7E7;\n  border: 1px solid #51B8B1;\n}\n\n.nav__link--inside:hover {\n  color: #51B8B1 !important;\n}\n\n.list {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  background-color: #51B8B1;\n}\n\n.list__item {\n  list-style: none;\n  width: 100%;\n  text-align: left;\n  overflow: hidden;\n  border-bottom: 2px solid #E7E7E7;\n}\n\n.list__item--click {\n  cursor: pointer;\n}\n\n.list__item_map {\n  list-style: none;\n  width: 100%;\n  text-align: left;\n  overflow: hidden;\n  border-bottom: 2px solid #E7E7E7;\n  height: 115px;\n}\n\n.list__button {\n  display: flex;\n  align-items: center;\n  gap: 1em;\n  width: 70%;\n  margin: 0 auto;\n}\n\n.btn-home__mobile {\n  width: 100%;\n  color: #322B4D;\n  background-color: #51B8B1;\n  cursor: pointer;\n  padding: 15px 0;\n  text-decoration: none;\n  border: 0;\n  text-align: left;\n  font-size: 16px;\n}\n\n.arrow .list__arrow {\n  transform: rotate(90deg);\n}\n\n.list__arrow {\n  margin-left: auto;\n  transition: transform 0.4s;\n}\n\n.list__sub__item {\n  max-height: 300px !important;\n  overflow-y: scroll !important;\n  list-style: none;\n  display: none;\n  scrollbar-color: #322B4D #95f8f1 !important;\n  scrollbar-width: thin !important;\n}\n\n.list__show {\n  display: block;\n  transition: ease 0.8s;\n  opacity: 100;\n}\n\n.list__hide {\n  display: none;\n  transition: opacity 200ms, display 200ms;\n  opacity: 0;\n}\n\n.div_ultima_menu {\n  background-color: yellow;\n  display: flex;\n  height: 100vh;\n}\n\n.list__button_ultima_menu {\n  overflow: hidden;\n  height: 100vh;\n}\n\n/* grilla de fotos del menu vertical*/\n.image-grid-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  width: 70%;\n}\n\n.image-grid-items {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px; /* Ajusta este valor según el margen deseado */\n}\n\n.image-grid-item {\n  margin: 0;\n  padding: 10px;\n  border: 1px solid #ccc;\n  background-color: #f9f9f9;\n  text-align: center;\n}\n\n.buttons {\n  margin-top: 10px;\n}\n\n/*  panel de cards de pdfs */\n.container_cards_viewpdf {\n  padding: 30px;\n  max-width: calc(100% - 50px);\n  background-color: #E7E7E7;\n}\n\n.conteiner-title--btn_card {\n  width: 300px;\n  height: 280px !important; /* Establece la altura de la tarjeta */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 2px solid #9283BE;\n  border-radius: 5px;\n  background-color: #fff;\n  max-width: calc(100% - 50px);\n}\n\n.card-title {\n  color: #E7E7E7;\n  background-color: #9283BE;\n  width: 100%;\n  height: 85px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  font-size: 0.8rem;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* Ajusta el ancho mínimo y máximo */\n  grid-gap: 20px;\n  width: 100%;\n}\n\n.main--pdfs {\n  background-image: url(\"./images/230602_micrositio_campana_contra _las _violencias_de_genero_ elementos_body_solapa.svg\");\n  min-height: 100vh;\n  width: 80%;\n}\n\n.btn {\n  width: 100%;\n}\n\n.image-card {\n  width: 258px;\n  height: 195px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.img-footer-desktopprincipal {\n  width: 100%;\n}\n\n/* Media querys  */\n@media (min-width: 1920px) {\n  .main--solapas, .main--buttons {\n    padding: 90px 40px 90px 40px;\n  }\n  .main--solapas h1 {\n    font-size: 2.7em;\n  }\n  .main--buttons {\n    padding: 85px;\n  }\n  .title-recursos {\n    padding: 15px;\n  }\n  .main--buttons h1 {\n    font-size: 2.2em;\n  }\n  h1 {\n    font-size: 1.6em;\n  }\n  h2 {\n    font-size: 1.9em;\n  }\n  .paragraph-genero, h3 {\n    font-size: 1.4em;\n  }\n  .paragraph-principal, .paragraph-second {\n    font-size: 1.8em;\n  }\n  /*Menu horizontal  */\n  .nav-menu--horizontal {\n    height: 110px;\n  }\n  /*Menu vertical  */\n  .list__button {\n    padding: 15px;\n  }\n  .title-aVozAlzada {\n    height: 125px;\n    text-align: center;\n  }\n  .nav {\n    width: 400px;\n  }\n  .navLink_solapas {\n    text-decoration: none;\n    position: absolute;\n    position: absolute;\n    top: 320px;\n    left: 10px;\n  }\n  .nav__link--inside:hover {\n    color: #51B8B1 !important;\n  }\n  .contenedor-buttons h3 {\n    font-size: 2rem;\n  }\n}\n@media screen and (min-width: 769px) and (max-width: 1024px) {\n  .a-link-nav-menu--horizontal {\n    font-size: 0.7em;\n  }\n  .nav {\n    width: 250px;\n  }\n  .nav__link {\n    font-size: 0.8rem;\n  }\n}\n@media (max-width: 768px) {\n  .nav {\n    width: 100%;\n  }\n  .nav__link--inside:hover {\n    color: #51B8B1 !important;\n  }\n  .section-menu-mobile {\n    display: flex;\n    flex-direction: column;\n  }\n  .section-menu-mobile img {\n    width: 100%;\n  }\n  .container-a-mobile {\n    display: flex;\n    flex-direction: column;\n    font-weight: 600;\n    height: 100%;\n  }\n  .container-a-mobile a {\n    text-decoration: none;\n    color: #444346;\n    line-height: 2rem;\n  }\n  .isActive {\n    display: block;\n    transition: transform 0.4s;\n    opacity: 100;\n    height: 100%;\n  }\n  .main--solapas h1 {\n    margin: 5px;\n    color: #322B4D;\n    padding: 15px;\n    text-align: center;\n    margin-bottom: 15px;\n    font-size: 1.75rem;\n  }\n  /*  contenedor imagenes a voz alzada */\n  .image-grid-container {\n    width: 100%;\n  }\n  .main--pdfs {\n    width: 80%;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  #width-view {\n    width: 50%;\n  }\n  #height_view__h1 {\n    font-size: 1.55rem;\n  }\n  #height_view__titulo {\n    font-size: 1.25rem;\n  }\n  #height_view__tituloimg {\n    font-size: 0.9rem;\n    max-width: calc(100% - 25px);\n  }\n}\n@media screen and (min-width: 901px) {\n  #nav-menu--horizontal {\n    display: flex !important;\n  }\n  #VerticalDrownMenu {\n    display: flex !important;\n  }\n  #nav-vertical-mobile {\n    display: none !important;\n  }\n  #header--destkop {\n    display: flex !important;\n  }\n  .HomeBody {\n    display: flex !important;\n  }\n  #article--movil {\n    display: none !important;\n  }\n  #footer_viewprincipal {\n    display: block !important;\n  }\n  #header--destkop__div {\n    display: block !important;\n  }\n  #footer_viewpimagenes {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 901px) {\n  #nav-vertical {\n    display: flex !important;\n  }\n  #nav-menu--horizontal {\n    display: none !important;\n  }\n  #VerticalDrownMenu {\n    display: none !important;\n  }\n  #nav-vertical-mobile {\n    display: block !important;\n  }\n  #header--destkop {\n    display: none;\n  }\n  .HomeBody {\n    display: none !important;\n  }\n  #article--movil {\n    display: block !important;\n  }\n  #footer_viewprincipal {\n    display: none !important;\n  }\n  #header--destkop__div {\n    display: none !important;\n  }\n  #footer_viewpimagenes {\n    display: block !important;\n  }\n  .container_cards_viewpdf {\n    width: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center; /* Centra verticalmente */\n    padding: 30px;\n    background-color: #E7E7E7;\n    max-width: calc(100% - 25px);\n  }\n  .conteiner-title--btn_card {\n    width: auto;\n    height: auto;\n    margin-bottom: 15px;\n  }\n  .main--solapas {\n    font-size: 1.125rem;\n    line-height: 1.5rem;\n  }\n  .buttons {\n    line-height: 1rem;\n  }\n  .main--solapas h1 {\n    color: #322B4D;\n    padding: 10px;\n    text-align: center;\n  }\n  .title-aVozAlzada {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    background-color: #a29dab;\n    height: 90px;\n  }\n  .title-aVozAlzada h1 {\n    text-align: center;\n    color: aliceblue;\n    font-size: 1.125rem;\n    margin: auto;\n  }\n  .title-recursos {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    background-color: #a29dab;\n    height: 90px;\n  }\n  .main--aVozAlzada p {\n    width: 70%;\n    font-size: 1.125rem;\n    line-height: 1.5rem;\n    color: #322B4D;\n  }\n  .image-card {\n    width: 260px;\n  }\n  .nav__link--inside:hover {\n    color: #51B8B1 !important;\n  }\n}\n@media (max-width: 500px) {\n  .paragraph-principal, .paragraph-second, .paragraph-genero {\n    font-size: 0.8em;\n  }\n  h1, h2 {\n    font-size: 1em;\n  }\n  .main--solapas h1 {\n    font-size: 1.35rem;\n    margin: 0;\n  }\n  .buttons {\n    font-size: 0.6em;\n  }\n  .nav__link {\n    height: auto !important;\n  }\n  .navLink_solapas {\n    display: none;\n  }\n  /* Imagenes de la grilla voz alzada SEGUIR TRABAJANDO*/\n  /* video spot */\n  .video-container {\n    width: 100%;\n    max-width: 1000px;\n    margin: 0 auto;\n    margin-top: 10%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .image-grid-items {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n    gap: 20px;\n  }\n  .main--aVozAlzada p {\n    width: 70%;\n    font-size: 1.125rem;\n    line-height: 1.5rem;\n    color: #322B4D;\n  }\n  .title-aVozAlzada {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    background-color: #a29dab;\n    height: 60px;\n  }\n  .title-aVozAlzada h1 {\n    text-align: center;\n    color: #E7E7E7;\n    font-size: 0.9rem;\n    margin: auto;\n  }\n  .title-recursos {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    background-color: #a29dab;\n    height: 60px;\n  }\n  .link-home {\n    text-decoration: none;\n    padding: 15px;\n  }\n  .mi-linea-horizontal {\n    display: none !important;\n  }\n  .nav__link--inside:hover {\n    color: #51B8B1 !important;\n  }\n  .main--buttons {\n    padding: 15px 40px 15px 40px;\n  }\n  .title-recursos {\n    height: 60px;\n  }\n}\n@media (max-width: 320px) {\n  .image-card {\n    width: 214px;\n  }\n  .nav__link--inside:hover {\n    color: #51B8B1 !important;\n  }\n  .title-aVozAlzada {\n    height: 70px;\n  }\n  .title-recursos {\n    height: 60px;\n  }\n  .main--solapas h1 {\n    font-size: 1.35rem;\n    margin: 0;\n  }\n  .main--buttons {\n    padding: 15px 40px 15px 40px;\n  }\n  .main--buttons_recursos {\n    padding: 15px 40px 15px 40px;\n  }\n}\n\n","* { \n  margin:0;\n  padding:0;\n}\n\n$white: #fff;\n$lima: #D6E034;\n$gris1: #E7E7E7;\n$gris-2: #444346;\n$gris-3: #a29dab;\n$grisCarousel: #c8c5cd;\n$violeta: #322B4D;\n$lila: #9283BE;\n$menta: #51B8B1;\n$celeste: #47BAEC;\n$menta-clara: #95f8f1; \n\n// Definimos las fuentes de todo el proyecto con @font-face\n@font-face {\n  font-family: \"EncodeSans-Bold\";\n  src: local(\"EncodeSans-Bold\"),\n  url(\"./fonts/EncodeSans-Bold.ttf\")\n}\n\n@font-face {\n  font-family: \"EncodeSans-Black\";\n  src: local(\"EncodeSans-Black\"),\n  url(\"./fonts/EncodeSans-Black.ttf\")\n}\n\n@font-face {\n  font-family: \"EncodeSans-Medium\";\n  src: local(\"EncodeSans-Medium\"),\n  url(\"./fonts/EncodeSans-Medium.ttf\")\n}\n\n@font-face {\n  font-family: \"EncodeSans-SemiBold\";\n  src: local(\"EncodeSans-SemiBold\"),\n  url(\"./fonts/EncodeSans-SemiBold.ttf\")\n}\n\n// Asignamos las fuentes declaradas antes a clases para usarlas en los componentes\n.encodesans-bold {\n  font-family: \"EncodeSans-Bold\";\n}\n.encodesans-black {\n  font-family: \"EncodeSans-Black\";\n}\n  .encodesans-medium {\n  font-family: \"EncodeSans-Medium\";\n}\n  .encodesans-semiBold {\n  font-family: \"EncodeSans-SemiBold\";\n} \n\n.btn-inicio { \n  position: absolute; \n  right: 20px;\n  top: 16%;\n  transform: translateY(-50%);\n  background-color: $violeta;\n  color: $gris1;\n  width: fit-content;\n  margin: 5px;\n  padding: 10px;\n  border-radius: 5px;\n  text-decoration: none;\n}\n\n/* principal page*/\n.HomeBody {\n  width: 80%;\n  background-image: url('./images/230602_micrositio_Campana_contra_las_violencias_de_genero_ elementos_body home-05.png');\n  background-size: cover; \n  background-repeat: round !important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  text-align: center;\n}\n\n.paragraph-principal  {\n  color: $gris1;\n  width: 70%!important;\n  height: 30%;\n  font-weight: 400;\n  font-size: 1.3em;\n  padding-top: 118px;\n  text-align: justify;\n}\n.paragraph-second {\n  color: $gris1;\n  width: 70%!important;\n  height: 30%;\n  font-weight: 400;\n  font-size: 1.3em;\n  margin-top: 30px;\n  text-align: justify;\n}\n.imgEncabezado {\n  vertical-align: bottom;\n}\n\n/*  infinite marquee*/\n#marquee-container {\n  width: 90%;\n  margin: 0 10px;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n.img-carrousel{\n  width: 80%;\n  height: auto;\n}\n#marquee-track {\n  display: flex;\n  margin-bottom: 60px;\n  animation: marquee 64s linear infinite; /* Cambiado a 64s para reflejar el tiempo doble */\n  animation-timing-function: linear;\n}\n\n.marquee-content {\n  margin-right: 20px; /* Espacio entre las imágenes */\n  flex-shrink: 0; /* Evita que las imágenes se redimensionen */\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(0%);\n  }\n  50% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n}\n/*.div--carousel {\n  background-color: #E7E7E7;\n} */\n/* principal page mobile*/\n.header--mobile {\n  background-image: url('./images/elementos_movil-v1_body-20.svg');\n  display: grid;\n  place-content: center;\n}\n\n/* nav */\n.conteiner--nav__mobile {\n  max-width: calc(100% - 50px); \n  padding: 25px; \n}\n.title--mobile {\n  border-radius: 5px;\n  color: $gris1;\n  text-align: center;\n  background-color: $violeta;\n  max-width: calc(100% - 50px); \n  padding: 25px; \n}\n.title--mobile_link {\n  text-decoration: none;\n  color: $gris1;\n}\n.paragraph--mobile {\n  color: $violeta;\n  background-color: $gris1;\n  font-weight: 600;\n  font-size: 1.125rem;\n  line-height: 1.5rem;\n  max-width: calc(100% - 50px); \n  padding: 25px; \n}\n\n/* background del menu vertical */\n.div-nav {\n  background-color: #9283BE;\n  height: 232vh;\n}\n\n/* videoSpot */\n.video-container {\n  width: 80%;\n  max-width: 1000px;\n  margin: 0 auto; \n  margin-top: 10%;\n  margin-bottom: 10%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.video-wrapper {\n  aspect-ratio: 16/9;\n  overflow: hidden;\n}\n\n.responsive-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* solapas    */\n/* paragraph */\n.paragraph-genero {\n  width: 70%!important;\n  color: $violeta;\n  margin-bottom: 20px;\n  font-size: 1rem;\n}\nimg {\n  width: 100%;\n  height: auto;\n}\n.mi-linea-horizontal {\n  width: 50%; /* Cambia el color de la línea horizontal */\n  border: 3px dashed $violeta; \n  margin: 20px 0 60px;\n}\n/* Vistas del menu vertical*/\n.main--buttons {\n    padding: 70px 40px 70px 40px;\n    background-image: url('./images/230602_micrositio_campana_contra\\ _las\\ _violencias_de_genero_\\ elementos_body_solapa.svg');\n    background-size: cover;\n    background-repeat: repeat-x;\n    width: auto;\n    height: auto;\n}\n.title-recursos {\n  height: 80px;\n  width: 80%;\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n  background-color: $gris-3;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5) !important;\n    h1 {\n      display: grid;\n      color: aliceblue;\n      place-content: center;\n      font-size: 1.2em;\n      margin: auto;\n    }\n}\n/*   */\n.main--buttons_recursos {\n  padding: 100px 40px 70px 40px;\n    background-image: url('./images/230602_micrositio_campana_contra\\ _las\\ _violencias_de_genero_\\ elementos_body_solapa.svg');\n    background-size: cover;\n    background-repeat: repeat-x;\n    width: auto;\n    height: auto;\n}\n/* Buttons */\n.buttons {\n  background-color: $violeta;\n  color: $gris1;\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  margin: 5px;\n  padding: 10px;\n  border-radius: 5px;\n  text-decoration: none;\n  img {\n    width: 16px;\n    height: 16px;\n    margin-right: 15px;\n  }\n}\n.contenedor-buttons {\n  display: grid;\n  place-items: flex-start;\n  h3 {\n    font-size: 18px;\n    color: $violeta;\n    margin-top: 10px;\n    margin-bottom: 20px;\n    font-family: encodesans-semiBold;\n  }\n}\n.main--solapas {\n  background-image: url('./images/230602_micrositio_campana_contra\\ _las\\ _violencias_de_genero_\\ elementos_body_solapa.svg');\n  background-size: cover; \n  background-repeat: repeat-x;\n  width: auto;\n  height: auto;\n  h1 {\n    font-size: 35px;\n    color: $violeta;\n    margin-bottom: 20px;\n  }\n}\n.main--solapas_custumizado {\n  background-image: url('./images/230602_micrositio_campana_contra\\ _las\\ _violencias_de_genero_\\ elementos_body_solapa.svg');\n  background-size: cover; \n  background-repeat: repeat-x;\n  width: auto;\n  height: 100vh;\n  h1 {\n    font-size: 35px;\n    color: $violeta;\n    margin-bottom: 20px;\n  }\n}\n.padding {\n  padding: 70px 40px 70px 40px;\n}\n/* menu horizontal desktop*/\n.conteiner-menus-desktop {\n  display: flex;\n  height: 80px;\n}\n.nav-menu--horizontal {\n  width: 80%;\n  background-color: $lima;\n  display: flex;\n  justify-content: center;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n}\n.a-link-nav-menu--horizontal {\n  padding: 1.5%;\n  width: 20%;\n  text-decoration: none;\n  text-align: center;\n  color: $gris-2;\n  box-shadow: 5px 0 0px 0 ;\n  display: flex;\n  font-weight: 700;\n  flex-direction: column;\n  justify-content: center;\n  font-size: 1em;\n}\n.active {\n  background-color: $violeta;\n  color: $gris1;\n}\n/*menu horizontal mobile */\n.section-menu-mobile {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.section-menu-mobile img {\n  width: 100%;\n}\n.container-a-mobile {\n  display: flex;\n  flex-direction: column;\n  font-weight: 600;\n}\n\n.container-a-mobile a {\n  text-decoration: none;\n  color: $gris-2;\n  line-height: 2rem;\n}\n\n.isActive {\n  display: flex;\n  height: 100vh;\n  opacity: 1;\n  height: 100%;\n}\n.toggleMenu--Mobile {\n  position: relative;\n}\n.btn-mobile {\n  position: absolute;\n    top: 17px;\n    /* right: -107px; */\n    left: 126px;\n    width: 26px;  \n    height: 26px;\n}\n/* mobile_vistas*/\n.article--movil {\n  background-image: url('./images/elementos_movil-v1_body-segundo-fondo-sin-logo.svg');\n  background-size: cover;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n}\n.div-paragraph__movil {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  flex-direction: column;\n    img {\n      width: 307px;\n      height: 140px;\n    }\n}\n.paragraph-movil {\n  color: $gris1;\n  width: 80%;\n  font-weight: 400;\n  font-size: 1.3em;\n\n}\n/* A voz alzada */\n.title-aVozAlzada {\n  height: 80px;\n  width: 80%;\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n  background-color: $gris-3;\n    h1 {\n      display: grid;\n      color: aliceblue;\n      place-content: center;\n      font-size: 1.2em;\n      margin: auto;\n    }\n}\n.main--aVozAlzada {\n  background-image: url('./images/230602_micrositio_campana_contra\\ _las\\ _violencias_de_genero_\\ elementos_body_solapa.svg');\n    p{\n      width: 70%;\n      font-size: 1.3em;\n      padding: 30px;;\n      color: $violeta;\n    }\n}\n\n\n/* vertical menu desktop */\n/*  contenedor de los menus que estan dentro del header   */\n.nav{\n  width: 300px;\n}\n\n.nav__link{\n  color: $violeta!important;\n  display: block;\n  padding: 15px 0;\n  text-decoration: none;\n  height: 50px;\n}\n\n.nav__link--inside{\n  padding-left: 20px;\n  text-align: left;\n  background-color: $gris1;\n  border: 1px solid $menta;\n}\n.nav__link--inside:hover {\n  color: $menta!important;\n}\n.list{\n  width: 100%;\n  // height: 100vh;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  background-color: $menta;\n}\n\n.list__item{\n  list-style: none;\n  width: 100%;\n  text-align: left;\n  overflow: hidden;\n  border-bottom: 2px solid $gris1;\n}\n.list__item--click{\n  cursor: pointer;\n}\n.list__item_map {\n  list-style: none;\n  width: 100%;\n  text-align: left;\n  overflow: hidden;\n  border-bottom: 2px solid #E7E7E7;\n  height: 115px;\n}\n.list__button{\n  display: flex;\n  align-items: center;\n  gap: 1em;\n  width: 70%;\n  margin: 0 auto;\n}\n.btn-home__mobile {\n  width: 100%;\n  color: $violeta;\n  background-color: $menta;\n  cursor: pointer;\n  padding: 15px 0;\n  text-decoration: none;\n  border: 0;\n  text-align: left;\n  font-size: 16px;\n}\n.arrow .list__arrow{\n  transform: rotate(90deg);\n}\n\n.list__arrow{\n  margin-left: auto;\n  transition: transform .4s;\n}\n\n.list__sub__item{\n  max-height: 300px !important;\n  overflow-y: scroll !important;\n  list-style: none;\n  display: none;\n  scrollbar-color:#322B4D #95f8f1 !important;\n  scrollbar-width: thin!important;\n}\n\n.list__show{\n  display: block;\n  transition: ease .8s;\n  opacity: 100;\n}\n\n.list__hide {\n  display: none;\n  transition: opacity 200ms, display 200ms;\n  opacity: 0;\n}\n\n.div_ultima_menu {\n  background-color: yellow;\n  display: flex;\n  height: 100vh;\n}\n.list__button_ultima_menu {\n  overflow: hidden;\n  height: 100vh;\n}\n/* grilla de fotos del menu vertical*/\n.image-grid-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  width: 70%;\n}\n\n.image-grid-items {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px; /* Ajusta este valor según el margen deseado */\n}\n\n.image-grid-item {\n  margin: 0;\n  padding: 10px;\n  border: 1px solid #ccc;\n  background-color: #f9f9f9;\n  text-align: center;\n}\n\n.buttons {\n  margin-top: 10px;\n}\n\n/*  panel de cards de pdfs */\n.container_cards_viewpdf {\n  padding: 30px;\n  max-width: calc(100% - 50px);\n  background-color: $gris1;\n}\n\n.conteiner-title--btn_card {\n  width: 300px;\n  height: 280px!important; /* Establece la altura de la tarjeta */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 2px solid $lila;\n  border-radius: 5px;\n  background-color: $white;\n  max-width: calc(100% - 50px);\n}\n\n.card-title {\n  color: #E7E7E7;\n  background-color: #9283BE;\n  width: 100%;\n  height: 85px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  font-size: 0.8rem;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* Ajusta el ancho mínimo y máximo */\n  grid-gap: 20px;\n  width: 100%;\n}\n\n.main--pdfs {\n  background-image: url('./images/230602_micrositio_campana_contra\\ _las\\ _violencias_de_genero_\\ elementos_body_solapa.svg');\n  min-height: 100vh;\n  width: 80%;\n}\n\n.btn {\n  width: 100%;\n}\n\n.image-card {\n  width: 258px;\n  height: 195px;\n  display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    \n}\n.img-footer-desktopprincipal {\n  width: 100%;\n}\n\n/* Media querys  */\n@media (min-width: 1920px) {\n  .main--solapas,  .main--buttons  {\n    padding: 90px 40px 90px 40px;\n  }\n  .main--solapas h1{\n    font-size: 2.7em;\n  }\n  .main--buttons {\n    padding: 85px;\n  }\n  .title-recursos {\n    padding: 15px;\n  }\n  .main--buttons h1{\n    font-size: 2.2em;\n  }\n  h1{\n    font-size: 1.6em;\n  }\n  h2{\n    font-size: 1.9em;\n  }\n\n  .paragraph-genero, h3{\n    font-size: 1.4em;\n  }\n  .paragraph-principal, .paragraph-second {\n    font-size: 1.8em;\n  }\n  /*Menu horizontal  */\n  .nav-menu--horizontal {\n    height: 110px;\n  } \n   /*Menu vertical  */\n  .list__button { \n  padding: 15px;\n  }\n  .title-aVozAlzada {\n    height: 125px;\n    text-align: center;\n  }\n  .nav {\n    width: 400px;;\n  }\n  .navLink_solapas {\n    text-decoration: none;\n    position: absolute;\n      position: absolute;\n      top: 320px;\n      left: 10px;\n  }\n  .nav__link--inside:hover {\n    color: $menta!important;\n  }\n  .contenedor-buttons {\n    h3 {\n      font-size: 2rem;\n  }\n  }\n}\n\n@media screen and (min-width: 769px) and (max-width: 1024px) {\n  .a-link-nav-menu--horizontal {\n    font-size: 0.7em;\n  }\n  .nav {\n    width: 250px;\n  } \n  .nav__link { \n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .nav{\n    width: 100%;\n  }\n  .nav__link--inside:hover {\n    color: $menta!important;\n  }\n  .section-menu-mobile {\n    display: flex;\n    flex-direction: column;\n  }\n  .section-menu-mobile img {\n    width: 100%;\n  }\n  .container-a-mobile {\n    display: flex;\n    flex-direction: column;\n    font-weight: 600;\n    height: 100%;\n  }\n  .container-a-mobile a {\n    text-decoration: none;\n    color: $gris-2;\n    line-height: 2rem;\n  }\n  .isActive {\n    display: block;\n    transition: transform 0.4s;\n    opacity: 100;\n    height: 100%;\n  }\n\n  .main--solapas h1{\n    margin: 5px;\n    color: $violeta;\n    padding: 15px;\n    text-align: center;\n    margin-bottom: 15px;\n    font-size: 1.75rem;\n}\n /*  contenedor imagenes a voz alzada */\n.image-grid-container {\n  width: 100%;\n}\n.main--pdfs {\n  width: 80%;\n}\n}\n\n//desktop\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  #width-view {\n    width: 50%;\n  }\n  #height_view__h1 {\n    font-size: 1.55rem;\n  }\n  #height_view__titulo {\n    font-size: 1.25rem;\n  }\n  #height_view__tituloimg {\n    font-size: 0.9rem;\n    max-width: calc(100% - 25px)\n  }\n}\n//destkop\n@media screen and (min-width: 901px) {\n  #nav-menu--horizontal {\n    display: flex !important;\n  }\n  #VerticalDrownMenu {\n    display:flex !important;\n  }\n  #nav-vertical-mobile {\n    display: none !important;\n  }\n  #header--destkop {\n    display:flex !important;\n  }\n  .HomeBody {\n    display: flex !important;\n  }\n  #article--movil {\n    display:none!important;\n  }\n  #footer_viewprincipal {\n    display: block!important;\n  }\n  #header--destkop__div {\n    display: block!important;\n  }\n  #footer_viewpimagenes {\n    display:none!important;\n  }\n}\n\n// mobile\n@media screen and (max-width: 901px) {\n\n    #nav-vertical{\n      display: flex !important;\n    }\n    #nav-menu--horizontal {\n        display: none !important;\n      }\n      #VerticalDrownMenu {\n        display:none !important;\n      }\n      #nav-vertical-mobile {\n        display:block!important;\n      }\n      #header--destkop {\n        display:none;\n      }\n      .HomeBody {\n        display:none!important;\n      }\n      #article--movil {\n        display:block!important;\n      }\n      #footer_viewprincipal {\n        display:none!important;\n      }\n      #header--destkop__div {\n        display: none !important;\n      }\n      #footer_viewpimagenes {\n        display:block!important;\n      }\n    .container_cards_viewpdf {\n      width: auto;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center; /* Centra verticalmente */\n      padding: 30px;\n      background-color: $gris1;\n      max-width: calc(100% - 25px);\n    }\n    .conteiner-title--btn_card {\n      width: auto;\n      height: auto;\n      margin-bottom: 15px;\n    }\n    .main--solapas {\n      font-size: 1.125rem;\n      line-height: 1.5rem;\n    }\n    .buttons {\n      line-height: 1rem;\n    }\n    .main--solapas h1 {\n      color: $violeta;\n      padding: 10px;\n      text-align: center;\n    }\n    .title-aVozAlzada {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      flex-direction: column;\n      background-color: #a29dab;\n      height: 90px;\n        h1 {\n          text-align: center;\n          color: aliceblue;\n          font-size: 1.125rem;\n          margin: auto;\n        }\n    }\n    .title-recursos {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      flex-direction: column;\n      background-color: #a29dab;\n      height: 90px;\n    }\n    .main--aVozAlzada {\n        p{\n          width: 70%;\n          font-size: 1.125rem;\n          line-height: 1.5rem;\n          color: $violeta;\n        }\n    }\n    .image-card {\n      width: 260px;\n    }\n    .nav__link--inside:hover {\n      color: $menta!important\n    }\n  }\n\n    @media (max-width: 500px) {\n      .paragraph-principal, .paragraph-second, .paragraph-genero {\n        font-size: 0.8em;\n      }\n      h1, h2 {\n        font-size: 1em;\n      }\n      .main--solapas h1 {\n        font-size: 1.35rem;\n        margin: 0;\n      }\n      .buttons {\n        font-size: 0.6em;\n      }\n      .nav__link {\n        height: auto !important;\n      }\n      .navLink_solapas {\n        display: none;\n      }\n      /* Imagenes de la grilla voz alzada SEGUIR TRABAJANDO*/\n      \n      /* video spot */\n      .video-container {\n        width: 100%;\n        max-width: 1000px;\n        margin: 0 auto; \n        margin-top: 10%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n      \n      .image-grid-items {\n        display: grid;\n        grid-template-columns: repeat(1, 1fr);\n        gap: 20px;\n      }\n      .main--aVozAlzada {\n        p{\n          width: 70%;\n          font-size: 1.125rem;\n          line-height: 1.5rem;\n          color: $violeta;\n        }\n      }\n      .title-aVozAlzada {\n        width: 100%;\n        display: flex;\n        justify-content: flex-end;\n        flex-direction: column;\n        background-color: #a29dab;\n        height: 60px;\n          h1 {\n            text-align: center;\n            color: $gris1;\n            font-size: 0.9rem;\n            margin: auto;\n          }\n      }\n      .title-recursos {\n        width: 100%;\n        display: flex;\n        justify-content: flex-end;\n        flex-direction: column;\n        background-color: #a29dab;\n        height: 60px;\n      }\n      .link-home {\n        text-decoration: none;\n        padding: 15px;\n      }\n      .mi-linea-horizontal {\n        display: none!important;\n      }\n      .nav__link--inside:hover {\n        color: $menta!important\n      }\n      .main--buttons {\n        padding: 15px 40px 15px 40px;\n      }\n      .title-recursos {\n        height: 60px;\n      }\n    }\n\n    @media (max-width: 320px){\n      .image-card{\n        width: 214px;\n      }\n      .nav__link--inside:hover {\n        color: $menta!important\n      }\n      .title-aVozAlzada {\n        height: 70px;\n      }\n      .title-recursos {\n        height: 60px;\n      }\n      .main--solapas h1 {\n        font-size: 1.35rem;\n        margin: 0;\n      }\n      .main--buttons {\n        padding: 15px 40px 15px 40px;\n      }\n      .main--buttons_recursos {\n        padding: 15px 40px 15px 40px;\n      }\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
